import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
  ScrollView,
} from "react-native";
import ENV from "app/utils/ENV";
import Constants from "expo-constants";
import colorHelpers from "app/utils/colorHelpers";
import Text from "app/components/Text";
// import { styleSheet, colors, sizes, WIDTH, test } from "app/utils/styleSheet";
import textHelpers from "app/utils/textHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import prefActions from "app/utils/prefActions";
import store from "app/redux/store";

import SideModal from "app/components/shared/SideModal";

import { StyleContext } from "app/contexts/Style";

export default class SettingsModal extends React.Component {
  static contextType = StyleContext;

  constructor(props) {
    super(props);
    let detailsMode = store.getState().preferences.detailsMode;
    this.state = {
      // lightScheme: "parchment",
      // darkScheme: "muted",
      // selectedSchemeMode: "auto",
      detailsMode,
      globalDetailsMode: detailsMode,
    };
  }

  componentDidMount() {
    // alert(this.context.color);
    this.subscribe();
  }

  componentWillUnmount() {
    this.unsubscribeRedux && this.unsubscribeRedux();
  }

  subscribe = async () => {
    if (!!this.unsubscribeRedux) return;
    this.unsubscribeRedux = store.subscribe(() => {
      let { preferences } = store.getState();
      if (preferences.detailsMode != this.state.globalDetailsMode) {
        this.setState({
          detailsMode: preferences.detailsMode,
          globalDetailsMode: preferences.detailsMode,
        });
      }
    });
  };

  render() {
    // let { lightScheme, darkScheme, selectedSchemeMode } = this.state;
    let { detailsMode } = this.state;
    let detailsOptions = prefActions.cycleOptions;
    let detailsOptionsFriendly = {
      titles: "Titles",
      all: "Changes",
    };

    let { lightTheme, darkTheme, schemeMode } = this.context;
    let lightSchemeOptions = ["parchment", "clarity", "newspaper_light"];
    let darkSchemeOptions = ["muted", "bold", "newspaper_dark"];
    let schemeModeOptions = ["auto", "light", "dark"];

    return (
      <SideModal
        width={400}
        title={"Settings"}
        onHide={this.props.onHide}
        sections={[
          {
            title: "Color Scheme",
            content: [
              <View style={[this.styles().row]}>
                <Text bold style={this.styles().label}>
                  Mode:
                </Text>
                {schemeModeOptions.map((opt, i) => (
                  <Text
                    key={i}
                    button
                    style={this.styles().button}
                    selectedButton={schemeMode == opt}
                    onPress={() => this.context.setSchemeMode(opt)}
                  >
                    {textHelpers.capitalize(opt.split("_")[0])}
                  </Text>
                ))}
              </View>,
              <View style={this.styles().row}>
                <Text bold style={this.styles().label}>
                  Light:
                </Text>
                {lightSchemeOptions.map((opt, i) => (
                  <Text
                    key={i}
                    button
                    style={this.styles().button}
                    selectedButton={lightTheme == opt}
                    onPress={() => this.context.setLightTheme(opt)}
                  >
                    {textHelpers.capitalize(opt.split("_")[0])}
                  </Text>
                ))}
              </View>,
              <View style={this.styles().row}>
                <Text bold style={this.styles().label}>
                  Dark:
                </Text>
                {darkSchemeOptions.map((opt, i) => (
                  <Text
                    key={i}
                    button
                    style={this.styles().button}
                    selectedButton={darkTheme == opt}
                    onPress={() => this.context.setDarkTheme(opt)}
                  >
                    {textHelpers.capitalize(opt.split("_")[0])}
                  </Text>
                ))}
              </View>,
            ],
          },
          {
            title: "Behavior",
            content: [
              <View style={this.styles().row}>
                <Text bold style={this.styles().label}>
                  Details:
                </Text>
                {detailsOptions.map((opt, i) => (
                  <Text
                    key={i}
                    button
                    style={this.styles().button}
                    selectedButton={detailsMode == opt}
                    onPress={() => {
                      if (detailsMode != opt) {
                        this.setState({ detailsMode: opt });
                        prefActions.setDetailsMode(opt);
                      }
                    }}
                  >
                    {textHelpers.capitalize(detailsOptionsFriendly[opt])}
                  </Text>
                ))}
              </View>,
            ],
          },
          {
            title: "Build",
            content: [
              <View style={this.styles().row}>
                <Text bold style={this.styles().label}>
                  Deployed:
                </Text>
                <Text style={[this.styles().button, this.styles().subtext]}>
                  {(() => {
                    const t = Constants.expoConfig?.extra?.buildTime || process.env.EXPO_PUBLIC_BUILD_TIME;
                    if (!t || typeof t !== "string") return "unknown";
                    const d = new Date(t);
                    return isNaN(d.getTime()) ? "unknown" : d.toLocaleString();
                  })()}
                </Text>
              </View>,
            ],
          },
          {
            title: "More",
            content: [
              <Text
                center
                button
                onPress={() => {
                  this.context.togglePensieveMode();
                  this.props.onHide();
                }}
                style={[
                  this.styles().button,
                  { flex: 1, marginTop: this.context.sizes.large },
                ]}
              >
                {this.context.pensieve ? "Gumball" : "Pensieve"} Mode
              </Text>,
              <Text
                center
                button
                onPress={() => {
                  this.context.toggleDemoMode();
                  this.props.onHide();
                }}
                style={[
                  this.styles().button,
                  { flex: 1, marginTop: this.context.sizes.large },
                ]}
              >
                {this.context.demo ? "Exit " : ""}Demo Mode
              </Text>,
              <Text
                center
                button
                onPress={() => {
                  this.context.toggleEmptyMode();
                  this.props.onHide();
                }}
                style={[
                  this.styles().button,
                  { flex: 1, marginTop: this.context.sizes.large },
                ]}
              >
                {this.context.emptyMode ? "Exit " : ""}Empty Mode
              </Text>,
              <Text
                selectedButton
                center
                onPress={() => {
                  RootNavigation.navigate("Settings");
                  this.props.onHide();
                }}
                style={{ flex: 1, marginTop: this.context.sizes.large }}
              >
                More Settings
              </Text>,
            ],
          },
        ]}
      />
    );
  }

  styles = () => ({
    row: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: this.context.color,
      // borderWidth: 2,
    },
    label: {
      minWidth: 50,
      marginRight: this.context.sizes.base,
      textAlign: "right",
    },
    button: {
      borderWidth: 1,
      borderColor: this.context.colors.trim,
    },
    gap: {
      height: this.context.sizes.large,
    },
    icon: {
      fontSize: this.context.sizes.default,
      color: this.context.colors.foreground,
      // backgroundColor: colorHelpers.hexToRgbaString(this.context.colors.fill, 0.8),
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.6
      ),
      borderRadius: this.context.sizes.smallBorderRadius,
      padding: 3,
    },
    subtext: {
      opacity: 0.6,
      fontStyle: "italic",
    },
  });
}
